import SeeMore from "../../../shared/SeeMore";

const InfoFidelityStep = ({fidelityId, acronym}) => {

    const textData = (fidelityId === 3) ? 
        `Por isso, você deve informar o usuário e a senha de acesso que estão 
        cadastrados no site da ${acronym}.`
     : 
        `Por isso, você deve informar o usuário e a senha de acesso que estão 
        cadastrados no site da ${acronym}.`;

    return (
        <SeeMore>
            <strong>Por que precisamos desses dados?</strong>

            <p>
                Para fazer a emissão de passagens utilizando suas milhas, a MaxMilhas precisará acessar 
                sua conta no programa de fidelidade.
                <br />
                <br />
                    {textData}
                <br />
                
                <br />
                Lembramos que o titular do programa de fidelidade deve ser o mesmo do cadastro da
                MaxMilhas.
            </p>
            <strong>Seus dados estão seguros</strong>
            <p>
                Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em segurança. Aqui, seus dados estão protegidos.
            </p>
            
        </SeeMore>
    );
}

export default InfoFidelityStep;